import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import {MeetingSortOrder} from 'nutshell-graphql-types';
import type {
    GetSchedulerMeetingsChat as GetSchedulerMeetingsChatQuery,
    GetSchedulerMeetingsChatVariables as GetSchedulerMeetingsChatQueryVariables,
} from 'nutshell-graphql-types';

import GET_SCHEDULER_MEETINGS_CHAT from '../queries/get-scheduler-meetings-chat.graphql';

export const useGetSchedulerMeetingsChat = (variables?: GetSchedulerMeetingsChatQueryVariables) => {
    const {data, error, loading, refetch} = useQuery<
        GetSchedulerMeetingsChatQuery,
        GetSchedulerMeetingsChatQueryVariables
    >(GET_SCHEDULER_MEETINGS_CHAT, {
        variables: {sort: MeetingSortOrder.BOOKABLE_FIRST, ...variables},
        fetchPolicy: 'cache-and-network',
    });

    const schedulerMeetings = data ? data.meetings : null;

    return {
        schedulerMeetings,
        isLoading: loading && !schedulerMeetings,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetchSchedulerMeetings: refetch,
    };
};
